import React, { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { StateContext } from "../components/context/ManageStates";
// import { TitleHeader, Singleimage, SmallComp } from '../components/common'
import { NavLink } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useMediaQuery } from 'react-responsive';
import DetailAction from "../redux/actions/DetailAction";
import CategoryAction from '../redux/actions/CategoryAction';
import RelatedAction from '../redux/actions/RelatedAction';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import useapidata from '../hooks/useApidata';
import useApidata from '../hooks/useApidata';
const Singleimage = lazy(() => import("../components/common/Singleimage"));
const SmallComp = lazy(() => import("../components/common/SmallComp"));
const TitleHeader = lazy(() => import("../components/common/TitleHeader"));

const Category = () => {


    const { slugs } = useParams();
    console.log("slug", slugs)
    const { getdetaillistdata } = DetailAction()
    const { getSubcategoryPostdatalistdata } = CategoryAction();
    const { useCategoryData } = useApidata()
    const { data: catData, isLoading } = useCategoryData(slugs)
    const { getRelatedPostslistdata } = RelatedAction()
    const category = useSelector(state => state.masterdata.cartdata);
    const hasmore = useSelector(state => state.masterdata.hasmore);
    const cartdisplay = useSelector(state => state.masterdata.cartdisplay);

    const page = useSelector(state => state.masterdata.page)
    const dispatch = useDispatch();
    // const [hasmaor, setHasmore] = useState(true)
    const categorylength =
        category &&
        category.display_items &&
        category.display_items.posts &&
        category.display_items.posts.length > 0 && // Check if posts array exists and is not empty
        category.display_items.posts[0] &&
        category.display_items.posts.length;
    const cattitle =
        category &&
        category.display_items &&
        category.display_items.posts &&
        category.display_items.posts.length > 0 && // Check if posts array exists and is not empty
        category.display_items.posts[0] &&
        category.display_items.posts[0].category_name;
    // const tags = ["travel", 'health', 'aritucture', 'food'];getRelatedPostslistdata
    // useEffect(() => {
    //     dispatch(getSubcategoryPostdatalistdata());
    // },[category]);



    useEffect(() => {
        dispatch({ type: "setCartdata", payload: [] });
        dispatch({ type: "setpage", payload: 1 });
        dispatch(
            getSubcategoryPostdatalistdata({
                page: 1,
                category_slug: slugs
            })
        );
    }, [dispatch, slugs]);

    // useEffect(()=>{


    // },[page])

    const fetchdata = () => {
        dispatch({ type: "setpage", payload: page + 1 });

        dispatch(
            getSubcategoryPostdatalistdata({
                page: page + 1,
                category_slug: slugs
            })
        );
    };

    const data = [
        {
            image: "https://utouchdesign.com/themes/envato/altroznews/images/news/lifestyle/travel5.jpg",
            category_name: "health",
            author_name: "Sridhar",
            discription: "Why The iPhone X Will Force Apple To Choose Between Good Or Evil",
            published_date: "20/20/2039",
        },
        {
            image: "https://utouchdesign.com/themes/envato/altroznews/images/news/lifestyle/health5.jpg",
            category_name: "travel",
            author_name: "murali",
            discription: "Early tourists choices to the sea of Maldiv…",
            published_date: "20/20/2039",
        },
        {
            image: "https://utouchdesign.com/themes/envato/altroznews/images/news/lifestyle/travel5.jpg",
            category_name: "health",
            author_name: "Sridhar",
            discription: "Why The iPhone X Will Force Apple To Choose Between Good Or Evil",
            published_date: "20/20/2039",
        },
        {
            image: "https://utouchdesign.com/themes/envato/altroznews/images/news/lifestyle/health5.jpg",
            category_name: "travel",
            author_name: "murali",
            discription: "Early tourists choices to the sea of Maldiv…",
            published_date: "20/20/2039",
        },
        {
            image: "https://utouchdesign.com/themes/envato/altroznews/images/news/lifestyle/health5.jpg",
            category_name: "travel",
            author_name: "murali",
            discription: "Early tourists choices to the sea of Maldiv…",
            published_date: "20/20/2039",
        },



    ]



    // console.log("data", catData)

    const isMobile = useMediaQuery({ query: '(min-width: 991px)' })
    return (
        <div className='text-dark'>
            <Row>{
                catData?.data?.data?.searchResult?.map((ele) => (

                    <Col lg={4} md={12}>
                        {
                            <NavLink to={`/detail/${ele.slug}`} className="text-decoration-none" >
                                <Suspense>

                                    <Singleimage
                                        image={
                                           
                                            `https://cdn.nurexify.com${ele.post_images?.desktop_banner?.[0]?.original || ""}`
                                        }
                                        discription={ele.title}
                                        author_name={ele.authorname}
                                        published_date={ele.published_on}
                                        content={ele.post_body}
                                    />
                                </Suspense>
                            </NavLink>
                        }

                    </Col>
                ))
            }

            </Row>

           

        </div>
    );
};

export default Category;